/**
 * @generated SignedSource<<f7aa15bff3fcf0f91e3b4dbf45d599ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LifetimeReferralsStats_referralsRef_qmee$data = {
  readonly lifetime: {
    readonly earnings: {
      readonly currency: string;
      readonly subUnitAmount: number;
    } | null;
    readonly successes: number;
  };
  readonly " $fragmentType": "LifetimeReferralsStats_referralsRef_qmee";
};
export type LifetimeReferralsStats_referralsRef_qmee$key = {
  readonly " $data"?: LifetimeReferralsStats_referralsRef_qmee$data;
  readonly " $fragmentSpreads": FragmentRefs<"LifetimeReferralsStats_referralsRef_qmee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LifetimeReferralsStats_referralsRef_qmee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReferralsStats",
      "kind": "LinkedField",
      "name": "lifetime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "successes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CurrencyAmount",
          "kind": "LinkedField",
          "name": "earnings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subUnitAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReferralHistory",
  "abstractKey": null
};

(node as any).hash = "1b4678f5648be97abc10411b08bca738";

export default node;
